const state = {
  tipoListaConsulta: '',
}

const getters = {
  getTipoListaConsulta: state => state.tipoListaConsulta,
}

const actions = {
  setTipolistaConsulta ({ commit }, value) {
    commit('changeTipoListaConsulta', value)
  },
  resetTipoListaConsultaModule({ commit }) {
    commit('changeTipoListaConsulta', '')
  }
}

const mutations = {
  changeTipoListaConsulta: (state, value) => (state.tipoListaConsulta = value),
}

export default {
  state,
  getters,
  actions,
  mutations,
}
